import React, { Component } from 'react';
import { browserName, browserVersion } from 'react-device-detect';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';

export class AccessForbidden extends Component {
    static displayName = AccessForbidden.name;
    //This is the page the user should land on if they tried to access a site they don't have permission to access. 
    //It is true that this site will display and be logged if the user attempts to access a site they have permissions for on an inactive level, but this isn't really too much of a 
    //concern for the moment since in order for that to happen the user will have to try and bypass the link obfuscation anyway.
    //If questions are raised, we can just add a blurb in the displayed text reminding the user to select the relevant level if they want to go to that page.
    //They'll have ten whole seconds to read it, that's longer than it sounds.
  constructor(props) {
    super(props);
      this.state = {
          returnable: [],
          browser: "",
          username: "",
          redirect: false, //This will be useful later when we send the user back to home
          ip: "",
      };
      this.getData();
      
    }

    async getData() {
        const response = await axios.get('https://geolocation-db.com/json/');
        this.setState({
            ip: response.data.IPv4 
        });
        this.getUserInfo();
    }

    componentDidMount() { //Once the offending user lands on this site, this function here will wait ten seconds and then set the redirect flag to true
        setTimeout(() => {
            this.setState({
                redirect: true
            })
        }, 10000)
    }

    async getUserInfo() { //The getUserInfo() and recordComingHere() is the same as everywhere else on the site, with the exception of not checking whether the user is supposed to be here
                          //If they're here at all, they've already tried to access somewhere they're not allowed and they won't be here for very long. All we need to record is whether
        //they got here at all.
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: data,
            browser: `${browserName}${browserVersion}`,
            username: data.username
        });
        this.recordComingHere();
    }

    async recordComingHere() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            pagePK: "-1",
            department: this.state.returnable.level,
            userPCID: this.state.returnable.pcid,
            ip: this.state.ip,
            browser: this.state.browser,
            userID: this.state.username
        }
        const response = await fetch('logging', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
    }

    render() {
        if (this.state.redirect) {
            this.props.passNewPage(1);//When the ten second wait timer in componentDidMount() ends, this.state.redirect will switch to true and force a rerender, which this will pick up on. This callback will
                                        //set the active page to Home
        }
    return (
      <div>
            <h1 style={{color: 'red'}}>Hold up. You're not supposed to be here.</h1>

            <p>If you believe you should have access to this page, make sure the active department in the upper-right gray dropdown is set to the department that has access to this page and double-check the hamburger menu beneath the Hood shield.</p>

            <p>If you still can't find this page and you think you should have it, please reach out to IT Applications to clarify.</p>

        <p>For now, we will send you back home</p>

      </div>
    );
  }
}
